import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import * as d3 from 'd3';
import { environment } from 'src/environments/environment';


interface Tag {
  libelle: string;
  users: { user: any }[];
}

@Component({
  selector: 'app-dupp-graph',
  templateUrl: './dupp-graph.component.html',
  styleUrls: ['./dupp-graph.component.scss']
})
export class DuppGraphComponent implements OnInit, AfterViewInit {

  @Input() subjects: any[] = [];
  @Input() contacts: any[] = [];
  @Input() projectUsers: any[] = [];
  @Input() projectLib: string = "Project";
  @Output() create = new EventEmitter<void>();
  @Output() quit = new EventEmitter<number>();
  @Output() submitProject: EventEmitter<any> = new EventEmitter();
  @Input() projectview = false;
  @Input() creator = null;
  projectLibelle = "Project";
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  projectUsersCopy: any[] = [];
  subjectsPerPage = 10;
  currentPage = 0;
  showDeletedNotification: boolean = false;
  searchContact: any;
  btnclicked = false;
  editingIndex: number | null = null;
  editingProject: boolean = false;
  editedLabel = '';
  oldLabel = '';
  editedLabelProject = '';
  oldLabelProject = '';

  /*positions = [               
    { top: '0%', left: '0%' },
    { top: '0%', left: '37%' },     // top
    { top: '0%', left: '74%' }, // top-right
    { top: '40%', left: '74%' },   // right
    { top: '80%', left: '74%' }, // bottom-right
    { top: '80%', left: '37%' },    // bottom
    { top: '80%', left: '0%' },      // bottom-left
    { top: '40%', left: '0%' }                  // top-left
  ];*/
  
  /*positions = [               // left
    { top: '0%', left: '0%' },
    { top: '0%', left: '37%' },     // top
    { top: '0%', left: '74%' }, // top-right
    { top: '37.5%', left: '74%' },   // right
    { top: '75%', left: '74%' }, // bottom-right
    { top: '75%', left: '37%' },    // bottom
    { top: '75%', left: '0%' },      // bottom-left
    { top: '37.5%', left: '0%' }                  // top-left
  ];*/
  positions = [               // left
    { top: '0%', left: '0%' },
    { top: '0%', left: '37%' },     // top
    { top: '0%', left: '74%' }, // top-right
    { top: '25%', left: '74%' },   // right
    { top: '50%', left: '74%' }, // bottom-right
    { top: '75%', left: '74%' }, // bottom-right
    { top: '75%', left: '37%' },    // bottom
    { top: '75%', left: '0%' },      // bottom-left
    { top: '50%', left: '0%' },               // top-left
    { top: '25%', left: '0%' }                  // top-left
  ];
  centerX = 185; // centre du svg (ex: 300px wrapper)
  centerY = 120.0;
  centerY2 = 240.0;
  center = 150;
  radius = 100;
  divwidth = 360;
  divheight = 360;
  diameter = this.center * 2;
  mode = 1;
  activeConfirmIndex: number | null = null;
  SubNum = 0;
  tagNameOne: string = '';
  addingTagMember = [];
  tagUserSelected = [];
  @ViewChild('parentiv', {static: false}) parentiv!: ElementRef<any>;

  selectedMembers: string[] = [];
  selectedSubject: string | null = null;

  projectName: string = '';
  creationDate: string = '25-08-2025';
  searchMember: string = '';
  tagRenameShow = false;
  projRenameShow = false;
  selectedTag = {
  libelle: 'test',
  users: []
};
  members = [
    { name: 'Catherine K.', email: 'catherine.k@gmail.com', avatarUrl: 'assets/avatars/catherine.jpg' },
    { name: 'Alexandre Bel...', email: 'alexandredeb@ yopmail.com', avatarUrl: 'assets/avatars/alexandre.jpg' },
    { name: 'Alex Bolzac', email: 'bolzac@comp@yahoo.fr', avatarUrl: 'assets/avatars/alex.jpg' },
    { name: 'Claude Koné', email: 'claude.k@face2faces.com', avatarUrl: 'assets/avatars/claude.jpg' },
    { name: 'Hamza Motaz...', email: 'Hamza@face2faces.com', avatarUrl: 'assets/avatars/hamza.jpg' },
    { name: 'Paul Fitoussi', email: 'contact@face2faces.com', avatarUrl: 'assets/avatars/paul.jpg' }
  ];

  ngAfterViewInit(): void {
    // Assure-toi que la div est bien rendue avant d'accéder à sa largeur
    const width = this.parentiv.nativeElement.offsetWidth;
    const height = this.parentiv.nativeElement.offsetHeight;
    this.divwidth = width;
    this.divheight = height;
    //this.centerX = width / 2;
    //this.centerY = height / 2;
    this.centerX = width / 2;
    this.centerY = (height / 100) * 37;
    this.centerY2 = (height / 100) * 61;
  }

  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thématique";
      } else return subject;
  }

  // Filter members based on search input
  filteredMembers() {
    return this.members.filter(member => 
      member.name.toLowerCase().includes(this.searchMember.toLowerCase()) ||
      member.email.toLowerCase().includes(this.searchMember.toLowerCase())
    );
  }

  scrollRight(container: HTMLElement) {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  }

  scrollLeft(container: HTMLElement) {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  }

    fctCheckMemberProject(userInfo){ 
      if(this.projectUsersCopy && !this.projectUsersCopy.includes(userInfo)){
        this.fctAdMemberProject(userInfo);
      } else this.fctRemoveUserProject(userInfo);
    }

    fctAdMemberProject(userInfo){ 
      this.projectUsersCopy.push(userInfo);
      this.searchContact = "";
    }

    fctRemoveUserProject(userInfo){
      const index = this.projectUsersCopy.indexOf(userInfo);
      if (index > -1) {
        this.projectUsersCopy.splice(index, 1);
        this.searchContact = "";
      }
    }

    isUserInTag(contact: any): boolean {
      if (!this.selectedTag || !this.selectedTag.users) return false;
      return this.selectedTag.users.findIndex(user => user.id === contact.id) !== -1;
    }

    fctCheckMemberTag(userInfo) {
      if (this.selectedTag.users && !this.selectedTag.users.some(user => user.id === userInfo.id)) {
        this.fctAdMemberTag(userInfo);
      } else {
        this.fctRemoveUserTag(userInfo);
      }
    }

    fctAdMemberTag(userInfo) {
      if (!this.selectedTag.users) {
        this.selectedTag.users = [];
      }
      this.selectedTag.users.push(userInfo);
      this.searchContact = "";
    }

    fctRemoveUserTag(userInfo) {
      const index = this.selectedTag.users.findIndex(user => user.id === userInfo.id);
      if (index > -1) {
        this.selectedTag.users.splice(index, 1);
        this.searchContact = "";
      }
    }


  getFormattedName(member: { givenName: string; familyName: string }): string {
    const firstInitial = member.familyName.charAt(0).toUpperCase();
    return `${member.givenName} .${firstInitial}`;
  }

  removeMember(member: any) {
    this.selectedTag.users = this.selectedTag.users.filter(m => m.email !== member.email);
  }

  removeProjectMember(member: any) {
    if(member.id) {
      this.projectUsersCopy = this.projectUsersCopy.filter(m => m.id !== member.id);
      for (let i = 0; i < this.subjects.length; i++) {
        for (let j = 0; j < this.subjects[i]['users'].length; j++) {
          if(this.subjects[i]['users'][j].id === member.id){
            this.subjects[i]['users'].splice(j, 1);
            break;
          }
        }
      }
    } else {
      this.projectUsersCopy = this.projectUsersCopy.filter(m => m.email !== member.email);
      for (let i = 0; i < this.subjects.length; i++) {
        for (let j = 0; j < this.subjects[i]['users'].length; j++) {
          if(this.subjects[i]['users'][j].email === member.email){
            this.subjects[i]['users'].splice(j, 1);
            break;
          }
        }
      }
    }
  }

  confirmEdit(i: number){
    this.paginatedSubjects[i].libelle = this.editedLabel;
    this.editingIndex = null;
  }

  editSubject(tag, index: number) {
    console.log("editSubject "+index);
    this.editingIndex = index;
    this.oldLabel = tag.libelle;
    this.editedLabel = this.oldLabel;
  }

  cancelEdit() {
    this.editingIndex = null;
    this.editingProject = null;
  }

  editProject() {
    this.editingProject = true;
    this.oldLabelProject = this.projectLibelle;
    this.editedLabelProject = this.oldLabelProject;
  }

  confirmEditProject(){
    this.projectLibelle = this.editedLabelProject;
    this.editingProject = null;
  }

  cancelEditProject() {
    this.editingIndex = null;
    this.editingProject = false;
  }

  addMemberToProject() {
    this.mode = 4;
  }

  addMemberToTag() {
    this.mode = 5;
  }

  

  createSubject(){
    this.mode = 6;
  }

  onNoClick(){
    this.tagNameOne = "";
    this.addingTagMember = [];
    this.mode = 1;
  }

  isUserInTagCreated(contact: any): boolean {
      if (!this.addingTagMember) return false;
      return this.addingTagMember.findIndex(user => user.id === contact.id) !== -1;
  }

    checkMemberTagCreated(userInfo) {
      if (this.addingTagMember && !this.addingTagMember.some(user => user.id === userInfo.id)) {
        this.adMemberTagCreated(userInfo);
      } else {
        this.removeUserTagCreated(userInfo);
      }
    }

    checkMailTagCreated(userInfo) {
      if (this.addingTagMember && !this.addingTagMember.some(user => user.email === userInfo.email)) {
        this.adMemberTagCreated(userInfo);
      } else {
        this.removeUserTagCreated(userInfo);
      }
    }

    isEmailInTagCreated(contact: any): boolean {
        if (!this.addingTagMember) return false;
        return this.addingTagMember.findIndex(user => user.email === contact.email) !== -1;
    }

    adMemberTagCreated(userInfo) {
      if (!this.addingTagMember) {
        this.addingTagMember = [];
      }
      this.addingTagMember.push(userInfo);
      this.searchContact = "";
    }

    removeUserTagCreated(userInfo) {
      const index = this.addingTagMember.findIndex(user => user.email === userInfo.email);
      if (index > -1) {
        this.addingTagMember.splice(index, 1);
        this.searchContact = "";
      }
    }

  addTagToProject(){
      var general = false;
      if(this.tagNameOne.trim() == "" || this.tagNameOne.trim().length == 0){
        alert("Veuillez entrer un canal");
        return;
      } 
      var tag : Tag = { // Déclare tag comme étant du type 'Tag'
        libelle: '',
        users: []
      };
      tag.libelle = this.tagNameOne.trim();
      tag.users.push(this.projectUsersCopy.find(user => user.id === this.currentUser.id));
      for (var i = 0; i < this.addingTagMember.length; i++) {
        tag.users.push(this.addingTagMember[i]);
      }
      this.subjects.push(tag);
      this.tagNameOne = "";
      this.addingTagMember = [];
      this.SubNum++;
      this.mode = 1;
    }

  prepareAndSubmit() {
      this.btnclicked = true;
      const payload = {
        libelle: this.projectLibelle,
        tags: this.subjects,
        userProject: this.projectUsersCopy
      };

    this.submitProject.emit(payload); // 🧠 Envoie au parent
  }

  get paginatedSubjects() {
    const start = this.currentPage * this.subjectsPerPage;
    return this.subjects.slice(start, start + this.subjectsPerPage);
  }

  get canGoNext(): boolean {
    return (this.currentPage + 1) * this.subjectsPerPage < this.subjects.length;
  }

  get canGoPrevious(): boolean {
    return this.currentPage > 0;
  }

  nextPage() {
    if (this.canGoNext) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.canGoPrevious) {
      this.currentPage--;
    }
  }

  getPositionPx(percent: string): number {
    //const percentValue = parseFloat(percent);
    const percentValue = (parseFloat(percent) + 13);
    //return (percentValue / 100) * 330; // wrapper width/height = 300
    return (percentValue / 100) * this.divwidth; // wrapper width/height = 300
  }

  getPositionPxTop(percent: string): number {
    //const percentValue = parseFloat(percent);
    const percentValue = (parseFloat(percent) + 12);
    //return (percentValue / 100) * 330; // wrapper width/height = 300
    return (percentValue / 100) * this.divwidth; // wrapper width/height = 300
  }


  // Détermine l'emplacement du prochain bouton "+"
  getNextSlotIndex(): number {
    if (this.subjects.length === 0) return 4;
    if (this.subjects.length === 1) return 1; 
    return -1; // pas d'emplacement prévu au-delà
  }

  ngOnInit() {
    var userData = JSON.parse(localStorage.getItem('currentUser'));
    this.projectLibelle = this.projectLib;
    this.projectUsersCopy= [...this.projectUsers];
    this.projectUsersCopy.unshift(userData);
    this.btnclicked = false;
    this.SubNum = this.subjects.length;
  }
  
  getAvatarlUrl(avatarLink){
      return environment.server_url+avatarLink;
  }

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  onQuit(){
    this.btnclicked = false;
    this.tagRenameShow = false;
    this.projRenameShow = false;
    if(this.mode == 1){
      this.subjects = [];
      this.projectUsersCopy = [];
      this.currentPage = 0;
      this.quit.emit(104);
    } if(this.mode == 4){
      this.mode = 3;
    } if(this.mode == 5){
      this.mode = 2;
    } else this.mode = 1;
  }

  selectAllUsers(){
    this.addingTagMember = [];
    this.projectUsers.forEach((item) => this.addingTagMember.push(item));
  }
  deselectAllUsers(){
    this.addingTagMember = [];
  }

  getX(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.cos(angle);
  }

  getY(index: number): number {
    const angle = (2 * Math.PI / (this.subjects.length + 1)) * index;
    return this.center + this.radius * Math.sin(angle);
  }

  emitCreate() {
    this.create.emit(); // ← déclenche l’événement vers le parent
  }

  showMembers(index: number) {
    this.selectedSubject = this.subjects[index].name || this.subjects[index].title || 'Canal';
    this.selectedMembers = this.subjects[index].users || [];
  }

  toggleDeleteConfirm(index: number) {
    // Active ou désactive la popup pour ce bouton
    this.activeConfirmIndex = this.activeConfirmIndex === index ? null : index;
  }

  cancelConfirm() {
    this.activeConfirmIndex = null;
  }

  confirmRemove(tag: any, index: number) {
    //this.subjects = this.subjects.filter(m => m.id !== tag.id);
    this.subjects.splice(index, 1);
    this.activeConfirmIndex = null;
    this.SubNum = this.subjects.length;

    // Optionnel : message
    alert("Le canal a été supprimé.");
  }

  removeTag(tag){
    if(confirm("Voulez vraiment suppprimer le canal "+tag.libelle)) {
      this.subjects = this.subjects.filter(m => m.id !== tag.id);
      alert("Le canal est supprimé.")
    }
  }

  updateTag(tag, i){
    this.selectedTag = tag;
    this.tagRenameShow = false;
    this.mode = 2;
  }

  updateProject(){
    this.selectedTag = null;
    this.tagRenameShow = false;
    this.projRenameShow = false;
    this.mode = 3;
  }

  renameProject(){
    this.projRenameShow = true;
  }

  renameTag(){
    this.tagRenameShow = true;
  }

  confirmUpdate(){
    this.tagRenameShow = false;
    this.projRenameShow = false;
  }

  countMembers(index: number) {
    return this.subjects[index].users.length || 0;
  }

  showProjectMembers(index: number) {
  }

  countProjectMembers() {
    return this.projectUsersCopy.length;
  }

  generateGradientDots(x1: number, y1: number, x2: number, y2: number, spacing: number): { x: number, y: number, opacity: number }[] {
    const points = [];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const steps = Math.floor(distance / spacing);

    for (let i = 0; i <= steps; i++) {
      const t = i / steps;
      //const opacity = 0.1 + t * 0.8; // de 0.2 à 1
      const opacity = 1; // de 0.2 à 1
      points.push({
        x: x1 + dx * t,
        y: y1 + dy * t,
        opacity: opacity
      });
    }

    return points;
  }


}
